import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Whether any Insights are published — controls public visibility of nav + home section.
export function useInsightsMeta() {
  const [meta, setMeta] = useState({ has_published: false, count: 0, loading: true });
  useEffect(() => {
    let active = true;
    api
      .get("/api/insights-meta")
      .then((r) => active && setMeta({ ...r.data, loading: false }))
      .catch(() => active && setMeta({ has_published: false, count: 0, loading: false }));
    return () => {
      active = false;
    };
  }, []);
  return meta;
}
